<template><article><h1>Custom Data</h1>
<h3 id="when-data-is-arraystring-type"><a class="header-anchor" href="#when-data-is-arraystring-type" aria-hidden="true">#</a> When <code v-pre>data</code> is <code v-pre>Array&lt;string&gt;</code> type</h3>
<p><example :value="example1"></example></p>
<h3 id="when-data-is-arrayobject-type"><a class="header-anchor" href="#when-data-is-arrayobject-type" aria-hidden="true">#</a> When <code v-pre>data</code> is <code v-pre>Array&lt;object&gt;</code> type</h3>
<p>Modify the <code v-pre>data-label</code> and <code v-pre>data-value</code> to change the field of the bound value and the displayed field.</p>
<p><example :value="example2"></example></p>
<div class="warning custom-block"><p class="custom-block-title">WARNING</p>
<p>In theory, <code v-pre>value</code> supports the object type, but you must ensure that the object references are consistent, otherwise the component cannot judge whether the two objects are equal.</p>
</div>
<h3 id="when-data-is-object-type"><a class="header-anchor" href="#when-data-is-object-type" aria-hidden="true">#</a> When <code v-pre>data</code> is <code v-pre>object</code> type</h3>
<p><example :value="example3"></example></p>
<div class="warning custom-block"><p class="custom-block-title">WARNING</p>
<p>Because the key of the object is a string type, <code v-pre>v-model</code> can only pass the string type.</p>
<p>But using <code v-pre>@change</code> can easily convert to a numeric type:</p>
<pre v-pre><code v-pre class="language-html"><span class="hljs-tag">&lt;<span class="hljs-name">vue-slider</span>
  <span class="hljs-attr">:value</span>=<span class="hljs-string">"''+ value"</span>
  <span class="hljs-attr">@change</span>=<span class="hljs-string">"val =&gt; value = +val"</span>
/&gt;</span>
</code></pre>
</div>
</article></template>

<script>
  import examples from '@/examples/data.ts'
  export default {
    data () {
      return {
        ...examples
      }
    }
  }
</script>